var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketForm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 32,
    viewBox: "0 0 20 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.42 14.0301L16.87 12.5001L4.77 0.390119C4.62788 0.24693 4.45483 0.138224 4.26414 0.0723494C4.07345 0.00647517 3.8702 -0.0148135 3.67 0.0101193C2.75051 0.0674871 1.85697 0.337947 1.06 0.800119C0.350001 1.34012 0 2.53012 0 4.39012V26.8101C0 28.7501 0.350001 29.9601 1.06 30.4201C1.87496 30.8382 2.76628 31.0865 3.68 31.1501C3.88259 31.1795 4.08924 31.1614 4.28363 31.0972C4.47801 31.033 4.65479 30.9244 4.8 30.7801L18.42 17.1701C18.8334 16.7542 19.0655 16.1916 19.0655 15.6051C19.0655 15.0187 18.8334 14.4561 18.42 14.0401",
    fill: "#FAFBFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketForm);
export default __webpack_public_path__ + "static/media/TicketForm.7e4c84d55c88f7b9adaa157d1ed20de8.svg";
export { ForwardRef as ReactComponent };